import React from "react";
import { useTranslation } from "react-i18next";
import FormField from "../../Common/FormField";
import { Heading } from "@americanexpress/dls-react";

const CurrentPersonalDetails = ({ formik }) => {
  const { t } = useTranslation("common");
  return (
    <section id="current-personal-info">
      <div className="row">
        <div className="col-xs-12">
          <h4 className="heading-4 dls-deep-blue pad-2-b">
            {t("newuser.currentPersonalInfoHeading")}
          </h4>
        </div>
      </div>
      <div className="row">
        <FormField
          id="currentFirstName"
          name="currentFirstName"
          label={t("newUserUK.fullFirstName")}
          value={formik.values.currentFirstName}
          onChange={formik.handleChange}
          error={formik.touched.currentFirstName && formik.errors.currentFirstName}
        />
        <FormField
          id="currentFullMiddleName"
          name="currentFullMiddleName"
          label={t("newUserUK.fullMiddleName")}
          value={formik.values.currentFullMiddleName}
          onChange={formik.handleChange}
          error={formik.touched.currentFullMiddleName && formik.errors.currentFullMiddleName}
        />
        <FormField
          id="currentFullLastName"
          name="currentFullLastName"
          label={t("newUserUK.fullLastName")}
          value={formik.values.currentFullLastName}
          onChange={formik.handleChange}
          error={formik.touched.currentFullLastName && formik.errors.currentFullLastName}
        />
        <FormField
          id="currentCompanyEmail"
          name="currentCompanyEmail"
          label={t("newUserUK.email")}
          value={formik.values.currentCompanyEmail}
          onChange={formik.handleChange}
          hint={t("newUserUK.emailInfo")}
          error={formik.touched.currentCompanyEmail && formik.errors.currentCompanyEmail}
        />
      </div>
    </section>
  );
};

export default CurrentPersonalDetails;
